import { FC, useEffect, useState } from 'react'
import { useForm/* , Controller */ } from 'react-hook-form'

import CONFIG from '../../../../config'
// import { utils } from '../../../utils'
import { FormResponseStatus } from '../../../models'
import { FormLabel, Input, Select, Title, Text, Textarea, Button, FormLabelError/* , DatePicker */ } from '../../UI'
import { examService } from '../../../services'

type ExamsLaboratoryFormProps = {
  className?: string,
  exam: any,
  patientId: string,
  relationshipTypes: any[],
  onSubmitChange(respStatus: FormResponseStatus): void
}

interface IExamsLaboratoryForm {
  email: string,
  relationshipTypeId: string,
  comment?: string/* ,
  dateExpiry: any */
}

const defaultValues: IExamsLaboratoryForm = {
  email: '',
  relationshipTypeId: '',
  comment: ''/* ,
  dateExpiry: '' */
}

const ExamsLaboratoryForm:FC<ExamsLaboratoryFormProps> = ({ className = '', exam, patientId, relationshipTypes, onSubmitChange }) => {
  const { register, handleSubmit, formState: { errors }, reset/* , getValues, control */ } = useForm<IExamsLaboratoryForm>({
    defaultValues
  })
  const [submited, setSubmited] = useState<boolean>(false)

  useEffect(() => {
    reset(defaultValues)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exam])

  const postForm = async (data: any, examId: string, patientId: string, patientType: string) => {
    const resp = await examService.postExamShare(data, examId, patientId, patientType)
    setSubmited(false)

    if(resp && resp.status === 'Ok') {
      setTimeout(() => onSubmitChange('SUCCESS'), 800)
    } else {
      setTimeout(() => onSubmitChange('ERROR'), 800)
    }
  }

  const onSubmit = (fData: IExamsLaboratoryForm) => {
    const { email, relationshipTypeId, /* dateExpiry, */ comment } = fData
    setSubmited(true)
    postForm({
      recipient_email: email,
      type_relationship: relationshipTypeId,
      // date_expiry: utils.getDateFormat(dateExpiry, 'YYYY-MM-DD'),
      comment
    }, exam.examId, patientId, exam.patientType)
  }

  return (
    <div className={`py-50 px-25 lg:px-50 ${className}`}>
      <Title weight="bold">Compartir exámenes</Title>

      <form noValidate autoComplete="off" className="mt-30" onSubmit={handleSubmit(onSubmit)}>
        <fieldset>
          <FormLabel required>E-mail del destinatario</FormLabel>
          <Input
            {...register('email', {
              required: 'Digita E-mail del destinatario',
              pattern: { value: CONFIG.FORM.PATTERN.EMAIL, message: 'Digita E-mail válido' }
            })}
            id="email"
            name="email"
            placeholder="Ingresa el e-mail del destinatario"
            fullWidth
            tabIndex={1}
            error={!!errors.email}
            className="mt-10"
          />
          {errors.email && <FormLabelError>{errors.email?.message}</FormLabelError>}
        </fieldset>

        <fieldset className="mt-20">
          <FormLabel required>Tipo de relación</FormLabel>
          <Select
            {...register('relationshipTypeId', { required: 'Selecciona el Tipo de relación' })}
            id="relationshipTypeId"
            name="relationshipTypeId"
            defaultValue=""
            fullWidth
            required
            tabIndex={2}
            error={!!errors.relationshipTypeId}
            className="mt-10"
          >
            <option value="" disabled>Selecciona el tipo de relación</option>
            {relationshipTypes.length && relationshipTypes.map((it: any) =>
              <option key={it.id} value={it.id}>{it.name}</option>
            )}
          </Select>
          {errors.relationshipTypeId && <FormLabelError>{errors.relationshipTypeId?.message}</FormLabelError>}
        </fieldset>

        {/* <fieldset className="mt-20">
          <FormLabel required>Fecha de caducidad</FormLabel>
          <div className="mt-5">
            <Controller
              control={control}
              name='dateExpiry'
              render={({ field }) => (
                <DatePicker
                  {...register('dateExpiry', { required: 'Selecciona Fecha de caducidad' })}
                  selected={getValues('dateExpiry')}
                  placeholderText="DD/MM/YYYY"
                  tabIndex={6}
                  openToDate={new Date()}
                  showYearDropdown
                  showMonthDropdown
                  fullWidth
                  error={!!errors.dateExpiry}
                  onChange={(date) => field.onChange(date)}
                />
              )}
            />
          </div>
          {errors.dateExpiry && <FormLabelError>{errors.dateExpiry?.message}</FormLabelError>}
        </fieldset> */}

        <fieldset className="mt-20">
          <FormLabel>Comentario <Text component="span" size="14" weight="default" inline>(Opcional)</Text></FormLabel>
          <Textarea
            {...register('comment')}
            id="comment"
            name="comment"
            placeholder="Ingresa un comentario"
            rows={3}
            fullWidth
            tabIndex={3}
            className="mt-10"
          />
        </fieldset>

        <fieldset className="mt-40">
          <Button
            type="submit"
            tabIndex={3}
            fullWidth
            disabled={submited}
          >COMPARTIR</Button>
        </fieldset>

      </form>
    </div>
  )
}

export { ExamsLaboratoryForm }